import {
    UserStatusPersonalManagerAvatarDefaultStyled,
    UserStatusPersonalManagerAvatarStyled,
    UserStatusPersonalManagerStyled,
} from './styled/UserStatusPersonalManagerStyled';
import BinIcon from '../../../components/icon/IconWrapped';
import { useSelector } from 'react-redux';
import { getAppUser } from '../../../app/appSelectors';
import { USER_STATUSES_STATES } from '../userStatusesConstants';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { Button } from 'react-bootstrap';
import { useZendeskContext } from '../../Zendesk/zendeskContext';
import { getIsZendeskInitedSelector } from '../../Zendesk/zendeskSelectors';
import { useCallback } from "react";

interface IUserStatusPersonalManagerProps {
    className?: string;
    statusState?: string;
}

function UserStatusPersonalManager(props: IUserStatusPersonalManagerProps) {
    const user = useSelector(getAppUser);
    const { getLangPath } = useLangContext();
    const {
        className,
        statusState = USER_STATUSES_STATES.PROGRESS,
    } = props;
    const { openWebWidget } = useZendeskContext();
    const isZendeskWebWidgetInited = useSelector(getIsZendeskInitedSelector);

    const onClickHandler = useCallback((e) => {
        isZendeskWebWidgetInited && openWebWidget();
    }, [isZendeskWebWidgetInited, openWebWidget]);

    return <UserStatusPersonalManagerStyled className={className}>
        {
            !user.personal_manager || statusState === USER_STATUSES_STATES.PLAN
                ? <div className={'d-flex align-items-center gap-2'}>
                    <UserStatusPersonalManagerAvatarDefaultStyled>
                        <BinIcon name={'IcManager'} size={32}/>
                    </UserStatusPersonalManagerAvatarDefaultStyled>
                    <span className={'f14 text-secondary'}>
                        {getLangPath('user_statuses.personal_manager.title')}
                    </span>
                </div>
                : <div className={'d-flex flex-column gap-3'}>
                    <div className={'d-flex gap-2 align-items-center'}>
                        <UserStatusPersonalManagerAvatarStyled>
                            <img src={user.personal_manager.avatar_img}/>
                        </UserStatusPersonalManagerAvatarStyled>
                        <div>
                            <div dangerouslySetInnerHTML={{
                                __html: getLangPath(
                                    'user_statuses.personal_manager.name_personal_manager',
                                    { name: user.personal_manager.name }
                                )
                            }}/>
                            <a href={`mailto:${user.personal_manager.email}`}
                               className={'text-secondary f14 text-decoration-none'}>{user.personal_manager.email}</a>
                        </div>
                    </div>
                    <Button
                        disabled={!isZendeskWebWidgetInited}
                        onClick={onClickHandler}
                        size={'sm'}
                        variant={'secondary'}
                    >
                        {getLangPath('user_statuses.personal_manager.contact')}
                    </Button>
                </div>
        }
    </UserStatusPersonalManagerStyled>
}

export default UserStatusPersonalManager;
